<template>
  <div>
    <el-row justify="end">
      <el-col :span="4">
        <el-divider content-position="left">メーカーマスタ設定</el-divider>
      </el-col>
      <el-col :span="20" style="text-align: right">
        <el-button type="primary" @click="openAddDialog">追加</el-button>
      </el-col>
    </el-row>
    <!-- 数据表格 -->
    <el-table
      :data="manufacturers"
      border
      style="width: 100%; margin-top: 10px"
      :header-cell-style="{ background: '#08455d', color: '#fff', fontWeight: 'bold' }"
    >
      <!-- 自动序号 -->
      <el-table-column label="No" width="60" align="center">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="code"
        label="コード"
        width="90"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="name_ja"
        label="内容 (日本語)"
        width="450"
      ></el-table-column>
      <el-table-column
        prop="name_en"
        label="内容 (英語)"
        width="450"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template v-slot="scope">
          <el-button
            type="warning"
            size="small"
            @click="openEditDialog(scope.row)"
            >変更</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="deleteManufacturer(scope.row.code)"
            >削除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加 & 编辑弹窗 -->
    <el-dialog
      :title="isEditing ? 'メーカー情報を変更' : 'メーカー情報を追加'"
      v-model="dialogVisible"
      width="400px"
    >
      <el-form label-width="120px">
        <el-form-item label="コード">
          <el-input v-model="form.code" :disabled="isEditing"></el-input>
        </el-form-item>
        <el-form-item label="内容 (日本語)">
          <el-input v-model="form.name_ja"></el-input>
        </el-form-item>
        <el-form-item label="内容 (英語)">
          <el-input v-model="form.name_en"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="saveManufacturer">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { supabase } from "@/supabase.js"; // 确保你已正确配置 supabase

export default {
  setup() {
    const manufacturers = ref([]);
    const dialogVisible = ref(false);
    const isEditing = ref(false);
    const form = ref({ code: "", name_ja: "", name_en: "" });

    // 📌 加载 `manufacturer_m` 数据
    const loadManufacturers = async () => {
      const { data, error } = await supabase
        .from("manufacturer_m")
        .select("*")
        .order("code");
      if (error) {
        ElMessage.error("データの取得に失敗しました。");
        console.error(error);
      } else {
        manufacturers.value = data;
      }
    };

    // 📌 打开添加窗口
    const openAddDialog = () => {
      isEditing.value = false;
      form.value = {code: "", name_ja: "", name_en: "" };
      dialogVisible.value = true;
    };

    // 📌 打开编辑窗口
    const openEditDialog = (row) => {
      isEditing.value = true;
      form.value = { ...row };
      dialogVisible.value = true;
    };

    // 📌 保存 (新增/更新)
    const saveManufacturer = async () => {
      if (!form.value.code || !form.value.name_ja || !form.value.name_en) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      let error;
      if (isEditing.value) {
        // 更新记录
        ({ error } = await supabase
          .from("manufacturer_m")
          .update({
            name_ja: form.value.name_ja,
            name_en: form.value.name_en,
          })
          .eq("code", form.value.code));
      } else {
        // 新增记录
        ({ error } = await supabase
          .from("manufacturer_m")
          .insert([form.value]));
      }

      if (error) {
        ElMessage.error("保存に失敗しました。");
        console.error(error);
      } else {
        ElMessage.success("データを保存しました。");
        dialogVisible.value = false;
        loadManufacturers();
      }
    };

    // 📌 删除记录
    const deleteManufacturer = async (code) => {
      ElMessageBox.confirm("このメーカー情報を削除しますか？", "確認", {
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(async () => {
          const { error } = await supabase
            .from("manufacturer_m")
            .delete()
            .eq("code", code);
          if (error) {
            ElMessage.error("削除に失敗しました。");
            console.error(error);
          } else {
            ElMessage.success("削除しました。");
            loadManufacturers();
          }
        })
        .catch(() => {
          ElMessage.info("削除をキャンセルしました。");
        });
    };

    onMounted(loadManufacturers);

    return {
      manufacturers,
      dialogVisible,
      isEditing,
      form,
      openAddDialog,
      openEditDialog,
      saveManufacturer,
      deleteManufacturer,
    };
  },
};
</script>

<style scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}
</style>
